import React from 'react';

import MFormFieldWrapView from './MFormFieldWrap.view';

type Props = {
  name?: string;
  displayName?: string;
  className?: string;
  error?: string | null;
  action?: JSX.Element | null;
  information?: string;
  errorClass?: string;
  displayNameClass?: string;
  descriptionTooltip?: string;
  tooltipClass?: string;
};

const MFormFieldWrap: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <MFormFieldWrapView
      name={props.name}
      displayName={props.displayName}
      className={props.className}
      error={props.error}
      action={props.action}
      errorClass={props.errorClass}
      displayNameClass={props.displayNameClass}
      descriptionTooltip={props.descriptionTooltip}
      information={props.information}
      tooltipClass={props.tooltipClass}
    >
      {props.children}
    </MFormFieldWrapView>
  );
};

MFormFieldWrap.displayName = 'MFormFieldWrap';
MFormFieldWrap.defaultProps = {};

export default MFormFieldWrap;
